import React from 'react';
import {Flex, CloseButton} from '@chakra-ui/react';
import {FilterSelect} from './FilterSelect';

const filterSelectionOptions = {
  true: {label: 'true', value: 'true'},
  false: {label: 'false', value: 'false'},
  is: {label: 'is', value: 'is'},
};

export const BooleanFilterControl = ({
  value,
  onChange,
  onRemove,
  isDisabled,
}: {
  value: boolean | undefined;
  onChange: (value: boolean) => void;
  onRemove: () => void;
  isDisabled?: boolean;
}) => {
  return (
    <Flex gap="2" flex={2} alignItems="center">
      <FilterSelect
        variant="operator"
        options={[filterSelectionOptions.is]}
        value={filterSelectionOptions.is}
        isDisabled={isDisabled}
      />
      <FilterSelect
        placeholder="Select..."
        value={
          value === undefined
            ? undefined
            : value
              ? filterSelectionOptions.true
              : filterSelectionOptions.false
        }
        onChange={(e) => {
          onChange(e?.value === 'true');
        }}
        options={[filterSelectionOptions.true, filterSelectionOptions.false]}
        isDisabled={isDisabled}
      />
      <CloseButton onClick={onRemove} />
    </Flex>
  );
};
